import { parseArrayResponse, parseStringResponse } from "../utils";
import IMediaPageScreenshots, {
    IMediaPageScreenshot,
} from "apiConsumers/kenticoApiConsumer/models/mediaPage/IMediaPageScreenshots";
import convertMediapageTagsResponse from "./convertMediapageTagsResponse";

export default function convertMediapageScreenshotsResponse(
    response: any
): IMediaPageScreenshots | undefined {
    const { items } = response;

    const parsedItems = parseArrayResponse(items);
    if (typeof parsedItems === "undefined") return undefined;

    let _screenshots: IMediaPageScreenshot[] = [];
    parsedItems.forEach((screenshot) => {
        const _screenshot = convertMediapageScreenshot(screenshot);
        if (typeof _screenshot === "undefined") return;

        _screenshots.push(_screenshot);
    });

    return {
        screenshots: _screenshots,
    };
}

function convertMediapageScreenshot(screenshotResponse: any): IMediaPageScreenshot | undefined {
    const { mediaItemTagListMediaItemTag, asset } = screenshotResponse;

    const { description, url } = asset[0].asset[0];

    const _src = parseStringResponse(url);
    if (typeof _src === "undefined") return undefined;

    const _alt = parseStringResponse(description);

    const _tags = convertMediapageTagsResponse(mediaItemTagListMediaItemTag);

    return { src: _src, alt: _alt, tags: _tags };
}
